(function () {
  var SEL = '.vit-rs__fotos .vit-rs__mini';
  var estilo = document.createElement('style');
  estilo.textContent = SEL + '{cursor:default!important;pointer-events:none!important;}';
  document.head.appendChild(estilo);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  estilo.textContent += '.vit-titulo__val{cursor:pointer!important;}';
  document.addEventListener('click', function (e) {
    var v = e.target && e.target.closest ? e.target.closest('.vit-titulo__val') : null;
    if (!v) return;
    var destino = document.getElementById('vitalce-resenas') || document.querySelector('.vit-rs');
    if (!destino) return;
    e.preventDefault();
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  function fijar() {
    document.querySelectorAll(SEL).forEach(function (b) {
      b.tabIndex = -1;
      b.setAttribute('aria-hidden', 'true');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fijar, { once: true });
  else fijar();
  var POR = 2;
  estilo.textContent += '@media screen and (min-width:750px){.vit-rs .vit-rs__lista{grid-template-columns:repeat(2,minmax(0,1fr))!important;}}';
  function tarjetas(raiz) {
    return Array.prototype.filter.call(raiz.querySelectorAll('.vit-rs__card'), function (c) { return !c.closest('.vit-rs__fotos'); });
  }
  function botonMas(raiz) {
    var b = raiz.querySelector('[data-ver-mas]');
    if (b) return b;
    var lista = raiz.querySelector('.vit-rs__lista');
    if (!lista) return null;
    var cont = document.createElement('div');
    cont.className = 'vit-rs__mas';
    b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('data-ver-mas', '');
    b.textContent = 'Ver más reseñas';
    cont.appendChild(b);
    lista.parentNode.insertBefore(cont, lista.nextSibling);
    return b;
  }
  function pasos() {
    document.querySelectorAll('vitalce-resenas').forEach(function (el) {
      var raiz = el.closest('.vit-rs') || el;
      if (raiz.__vitPasos) return;
      var cs = tarjetas(raiz);
      if (!cs.length) return;
      raiz.__vitPasos = true;
      cs.forEach(function (c, i) { if (i >= POR) { c.hidden = true; c.setAttribute('data-extra', ''); } else { c.hidden = false; } });
      var b = botonMas(raiz);
      if (!b) return;
      var cont = b.closest('.vit-rs__mas') || b;
      cont.hidden = cs.length <= POR;
      raiz.querySelectorAll('[data-ver-todas]').forEach(function (t) { t.hidden = true; });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ver-mas]') : null;
    if (!b) return;
    var raiz = b.closest('.vit-rs') || b.closest('vitalce-resenas');
    if (!raiz) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var ocultas = tarjetas(raiz).filter(function (c) { return c.hidden; });
    ocultas.slice(0, POR).forEach(function (c) { c.hidden = false; });
    if (ocultas.length <= POR) { var cont = b.closest('.vit-rs__mas') || b; cont.hidden = true; }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pasos, { once: true });
  else pasos();
  window.addEventListener('load', pasos);
})();
